import _ from 'underscore';
import { keywordPlannerSupportedLanguages } from '@bingads-webui-campaign-legacy/location-targets/util/constants';
import {
  languageOptions,
} from '@bingads-webui-campaign-react/keyword-planner-shared';

const languagesAllNumber = 1000;

const keywordPlannerSupportedLanguagesIdValueMap = _.invert(keywordPlannerSupportedLanguages);
const supportedLanguages = _.keys(keywordPlannerSupportedLanguages);

export const getSupportedLanguages = (languages, permissions) => {
  if (permissions && permissions.dynamic && permissions.dynamic.KeywordPlannerLiteRefactorPhase1) {
    return _.contains(languages, 'All') ? _.map(languageOptions, language => language.id) : languages;
  }
  if (_.contains(languages, 'All') || _.contains(languages, languagesAllNumber)) {
    return supportedLanguages;
  }
  // convert numbers to string
  const languages2Use = _.chain(languages)
    .map((lang) => {
      if (_.isNumber(lang)) {
        return keywordPlannerSupportedLanguagesIdValueMap[lang]; // undefined if not supported
      }
      return lang;
    }).compact().value();

  return _.intersection(languages2Use, supportedLanguages);
};
